import React from 'react';
import { Typography } from '@material-ui/core';

export const RequiredFieldIndicator = () => (
    <Typography color="error" component="span">
        *
    </Typography>
);
